<template>
  <Select
    :items="tiposDeConta"
    :selectedItem="filter.tipoDeConta"
    :label="filtro.name"
    :searchPlaceholder="filtro.placeholder"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
    :fixo="filtro.fixo"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        tipoDeConta: {
          id: "",
          name: "",
        },
      },
      tiposDeConta: this.filtro.opcoes || [],
    };
  },
  methods: {
    atualizar(tipoDeConta) {
      this.filter.tipoDeConta = tipoDeConta;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.tipoDeConta.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.tipoDeConta.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.tiposDeConta, this.filter.tipoDeConta);
  }
}
</script>
